export default "__VITE_ASSET__C89MrAvm__"